import React, { Component } from 'react';
import { InactivityMonitorConstants } from './InactivityMonitorConstants';
import { connect } from 'react-redux'
import './InactivityMonitor.scss';
import auth from '../../services/auth/AuthProvider';
import BaseModal from '../modal/baseModal';
import InactivityMonitorContent from './InactivityMonitorContent';
import AuthActions from '../../store/authRedux'

class InactivityMonitor extends Component {
    constructor(props) {
        super(props);

        this.activityTimer = null;

        this.lastActivityTime = null;

        this.state = {
            showModal: false,
            signedIn: props.signedIn
        };

        window.onload = () => { this.resetActivity() };
        window.onmousemove = () => { this.resetActivity() };
        window.onkeydown = () => { this.resetActivity() };
        window.onmousedown = () => { this.resetActivity() };
        window.onscroll = () => { this.resetActivity() };
        window.onclick = () => { this.resetActivity() };
    }

    componentDidMount() {
        if (auth.isAuthenticated()) {
            this.lastActivityTime = new Date().getTime();
            this.startMonitoring()
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.signedIn !== this.state.signedIn) {
            this.setState({ signedIn: newProps.signedIn })
            if (newProps.signedIn && !this.activityTimer) {
                this.lastActivityTime = new Date().getTime();
                this.startMonitoring();
            }
        }
    }

    resetActivity = () => {
        if (!this.state.showModal) {
            this.lastActivityTime = new Date().getTime();
        }
    }

    startMonitoring = () => {
        this.activityTimer = setInterval(() => {
            if (!this.state.showModal && auth.isAuthenticated()
                && (new Date().getTime() - this.lastActivityTime) >
                InactivityMonitorConstants.TIME_TO_WARNING_MINS * 60 * 1000) {
                this.setState({ showModal: true })
            }
        }, InactivityMonitorConstants.MONITOR_INTERVAL_MS);
    }

    staySignedIn = () => {
        this.resetActivity();
        this.setState({ showModal: false })
    }

    logoutUser = () => {
        this.props.logoutUser()
    }

    render() {
        return (
            <BaseModal show={this.state.showModal} hideHeader={true} isNarrow={true}>
                <InactivityMonitorContent started={this.state.showModal} onStaySignedIn={this.staySignedIn} logoutUser={this.logoutUser} />
            </BaseModal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        signedIn: state.auth.signedIn
    }
}

const mapDispatchToProps = (dispatch) => ({
    logoutUser: () => dispatch(AuthActions.logoutUser())
})

export default connect(mapStateToProps, mapDispatchToProps)(InactivityMonitor);